import { createSvgIcon } from '@mui/material';

export const NotificationsCheckmarkIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="7" />
        <circle cx="7" cy="7" r="6.5" stroke="currentColor" />
        <path
            d="M4 7.5L6 9.5L10 5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'NotificationsCheckmarkIcon'
)
